(() => {
  angular
    .module('gm.common.navigation')
    .factory('GmySlideNavigation', GmySlideNavigation);

  function GmySlideNavigation() {
    'ngInject';

    let slideNavigationOpen = false;

    return {
      close,
      isOpen,
      open,
      toggle,
    };

    function close() {
      slideNavigationOpen = false;
    }

    function isOpen() {
      return slideNavigationOpen;
    }

    function open() {
      slideNavigationOpen = true;
    }

    function toggle() {
      slideNavigationOpen = !slideNavigationOpen;
    }
  }
})();
